var _defs, _path, _path2, _path3, _rect, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPixel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #28abe3;\n      }\n\n      .cls-2 {\n        fill: #144dc0;\n      }\n\n      .cls-3 {\n        fill: #1e8ad3;\n      }\n\n      .cls-4 {\n        fill: #176bc3;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M4.8.44h4.31v5.78H3.33V1.91c0-.81.66-1.46,1.46-1.46Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.33,6.22h5.78v5.78h-4.31c-.81,0-1.46-.66-1.46-1.46v-4.31h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.8,17.78h4.31v4.3c0,.82-.66,1.48-1.48,1.48h-2.84c-.81,0-1.46-.66-1.46-1.46v-2.85c0-.81.66-1.46,1.46-1.46Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 9.11,
    y: 12,
    width: 5.78,
    height: 5.78
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14.89,12h5.78v4.31c0,.81-.66,1.46-1.46,1.46h-4.31v-5.78h0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.89,6.22h4.31c.81,0,1.46.66,1.46,1.46v4.31h-5.78v-5.78h0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.11.44h4.31c.81,0,1.46.66,1.46,1.46v4.31h-5.78V.44h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixel);
export default __webpack_public_path__ + "static/media/pixel.f7399155e5dbf256fed5ec18c9c523a2.svg";
export { ForwardRef as ReactComponent };